export { default } from './AuthContent'
